export default "/assets/images/our-story-mobile.1e021a5ab02a272e.webp";